import { useFetch } from "~vue/api";
import { computed } from "vue";

const ALREADY_OPEN = 409;

/**
 * Open an assessment session so that visiting `/perspective/` lands on the questions
 * rather than the intro. Resolves true when a session is open (newly created, or 409
 * because one is already in progress / completed); false on any other failure.
 */
export const useOpenPerspectiveSession = () => {
    const { execute, isFetching, statusCode, error } = useFetch("/v1/perspectives/sessions", { immediate: false }).post({}).json();

    const openSession = async (): Promise<boolean> => {
        await execute();
        return statusCode.value !== null && (statusCode.value < 400 || statusCode.value === ALREADY_OPEN);
    };

    const errorMessage = computed(() => (error.value && statusCode.value !== ALREADY_OPEN ? "Could not start your assessment. Please try again." : null));

    return { openSession, isOpening: isFetching, errorMessage };
};
